<template>
    <div>
      <!-- ========== MAIN CONTENT ========== -->
      <main id="content" role="main">
        <!-- Hero -->
        <section class="content-title">
          <div class="container ">
            <div
              class="position-relative content-space-t-1 content-space-b-lg-1 content-space-t-lg-3"
            >
              <div class="row">
                <div class="col-12">
                  <div class="row align-center content-logo">
                    <div
                      class="bg-logo mt-2 cursor-pointer"
                      @click="$router.push('/')"
                    >
                    IZIPARK
                      <!-- <img :src="logo" width="50px" alt="" class="logo-login" /> -->
                    </div>
                    <div class="mb-7 col title-txt">
                      <h1 class="mb-3 title-login " >Privacidad</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
  
        <!-- End Hero -->
  
        <!-- Content -->
        <div class="container" v-if="privacy && privacy.length > 0">
          <div class="row">
            <div class="col-md-12 col-lg-12 mx-auto">
              <div id="navblock1" class="mb-7">
                <div class="privacy-policy">
                  <div class="paragraph" style="white-space: pre-wrap;" v-html="privacy[0].description"></div>
                </div>
              </div>
              <div id="stickyBlockEndPoint"></div>
            </div>
            <!-- End Col -->
          </div>
          <!-- End Row -->
        </div>
        <!-- End Content -->
      </main>
      <!-- ========== END MAIN CONTENT ========== -->
    </div>
  </template>
  
  <script>
  import { mapState } from "vuex";
  
  export default {
    name: "Privacy",
    async created() {
      await this.$store.dispatch("Privacy/getListAll");
    },
    computed: {
      ...mapState({
        privacy: (state) => state.Privacy.list,
      }),
    },
    data: () => ({
      logo: require("../../assets/logo.png"),
    }),
  };
  </script>
  
  <style scoped>
  .title-login {
    font-weight: bold;
    font-size: 38px;
    transform: translate(2px, 0px);
    color: white;
  }
  .content-title {
    background-color:#335C9D !important;
    justify-content: center;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .title-txt {
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-top: auto;
    margin-bottom: auto;
  }
  .bg-logo {
    background-color: #335C9D;
    display: flex;
    max-width: 180px;
    padding: 10px;
    margin-top: 10px;
    margin-left: 10px;
    margin-bottom: 10px;
    color: antiquewhite;
  }
  .text-center-content {
    text-align: center;
    padding-left: 170px;
  }
  @media (max-width: 751px) {
    .text-center-content {
      text-align: center;
      padding-left: 0px;
    }
    .content-logo {
      justify-content: center;
      /* color: white;
      background-color: #335C9D; */
    }
  }
  
  @media (min-width: 1904px) {
    .container {
      max-width: 1785px;
    }
  }
  
  @media (min-width: 1264px) {
    .container {
      max-width: 1185px;
    }
  }
  .privacy-policy {
    font-family: "Times New Roman", serif;
  }
  
  h1 {
    text-align: center;
  }
  
  .paragraph {
    margin-bottom: 1.5em;
    text-align: justify;
  }
  .paragraph p {
    margin-bottom: 0.5em !important;
    text-align: justify;
  }
  p {
    line-height: 1.5;
    text-align: justify;
  }
  </style>
  